<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <div class="row">
          <div class="col-8">

               <h3 class="mt-1">{{ brand.name }}</h3>

            <div v-if="userHasPerms(['Manage products'])">
              <router-link
                v-b-tooltip.hover
                title="Edit"
                :to="{
                  name: 'brands-edit',
                  params: { id: brand.id },
                }"
                class="text-primary table-action-icon ml-0"
              >
                <i class="lni lni-pencil"></i>
              </router-link>

              <span
                v-b-tooltip.hover
                style="cursor: pointer"
                title="Delete"
                @click="confirmDelete(brand.id)"
                class="text-danger table-action-icon"
              >
                <i class="lni lni-trash"></i>
              </span>
            </div>
          </div>
          <div class="col-4">
            <v-lazy-image
              v-if="brand.image"
              :src="brand.image"
              class="img-fluid maxHeight200"
            />
          </div>
        </div>
        <table class="table table-sm">
      

          <table-row icon="lni-database" :noBorder="true" />

          <table-row label="Id">
            {{ brand.id }}
          </table-row>

          <table-row label="Created">
            {{
              moment(new Date(brand.created_at)).format("DD MMM YYYY, HH:mm:ss")
            }}
          </table-row>
          <table-row label="Updated">
            {{
              moment(new Date(brand.updated_at)).format("DD MMM YYYY, HH:mm:ss")
            }}
          </table-row>
        </table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import brandRepo from "@/api/repos/brandRepo";
import tableRow from "@/components/common/TableRow";

export default {
  props: ["id"],

  components: {
    tableRow,
  },

  mounted() {
    this.getBrand();
  },

  data() {
    return {
      loading: false,
      brand: {},
    };
  },

  methods: {
    async deleteBrand(id) {
      this.isBusy = true;
      try {
        await brandRepo.delete(id);
       this.$emit("brandUpdated");
      } catch (error) {
        console.log(error);
      } finally {
        this.isBusy = false;
      }
    },
    confirmDelete(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete the brand.", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((confirm) => (confirm ? this.deleteBrand(id) : false))
        .catch((error) => console.log(error));
    },
    async getBrand() {
      try {
        this.loading = true;
        let { data } = await brandRepo.get(this.id);
        this.brand = data.brand;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
